import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  getIsSignedIn,
  getLoadCachedUserAttempted,
  getShouldReauthenticate
} from '../../features/loginSystem/selectors';
import { loginRoute } from '../../routes/routes';
import AppContainer from './AppContainer';

function getRedirectUrl(location) {
  return location.pathname + location.search;
}

function PrivateRoute({
  path,
  from,
  render,
  children,
  // Using lower case c in component to use name pattern as <Route /> from react-router-dom
  component: Component,
  showAppContainer = true,
  exact
}) {
  const isSignedIn = useSelector(getIsSignedIn);
  const loadCachedUserAttempted = useSelector(getLoadCachedUserAttempted);
  const reauthenticate = useSelector(getShouldReauthenticate);

  function renderRouteContent() {
    let content = null;
    if (render) {
      content = render();
    } else if (Component) {
      content = <Component />;
    } else if (children) {
      content = children;
    }
    return showAppContainer ? <AppContainer>{content}</AppContainer> : content;
  }

  return (
    <Route
      path={path}
      from={from}
      exact={exact}
      render={props => {
        if (isSignedIn) {
          return renderRouteContent();
        }
        if (loadCachedUserAttempted || reauthenticate) {
          const redirect = getRedirectUrl(props.location);
          return <Redirect to={loginRoute({ redirect })} />;
        }
        return null;
      }}
    />
  );
}

export default PrivateRoute;
